import React from 'react';
import PropTypes from 'prop-types';
import cn from '../utils/cn';
import styles from './Skeleton.module.css';

const Skeleton = React.forwardRef(function Skeleton(
  { width, height, radius, className, style, ...rest },
  ref
) {
  return (
    <span
      ref={ref}
      className={cn(styles.root, className)}
      style={{ width, height, borderRadius: radius, ...style }}
      {...rest}
    />
  );
});

Skeleton.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  radius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  style: PropTypes.object
};

export default Skeleton;
